export default {
  form: {
    header: {
      label: 'Cabeçalho',
      placeholder: 'Cabeçalho',
    },
    sub_header: {
      label: 'Subcabeçalho',
      placeholder: 'Subcabeçalho',
    },
    qr_code_header: {
      label: 'Título da caixa',
      placeholder: 'Título da caixa',
    },
    qr_code_description: {
      label: 'Descrição da caixa',
      placeholder: 'Descrição da caixa',
    },
    footer: {
      label: 'Texto do rodapé',
      placeholder: 'Introduza o texto do rodapé',
    },
    url_type: {
      label: 'URL',
      placeholder: 'Selecionar URL',
    },
    url: {
      placeholder: 'www.example.com',
    },
    primary_color: {
      label: 'Cor primária',
    },
    background_color: {
      label: 'Cor de fundo',
    },
    cover_image: {
      label: 'Imagem de capa',
    },
    logo: {
      label: 'Logótipo',
    },
  },
  toasts: {
    failed_to_load_data: 'Falha ao carregar o folheto',
  },
};
